module.exports = new __parcel__URL__("mission_btn_disabled.3e01f265.png").toString();